/**
 * @generated SignedSource<<c6d799af92c88ace62d0dce5d69713cd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: string | null | undefined;
  patch: UserPatch;
  rowId: any;
};
export type UserPatch = {
  firstName?: string | null | undefined;
  isEmailMarketingEnabled?: boolean | null | undefined;
  isEmailNotificationsEnabled?: boolean | null | undefined;
  isMetricSystem?: boolean | null | undefined;
  lastName?: string | null | undefined;
  offerCodes?: ReadonlyArray<string | null | undefined> | null | undefined;
  rowId?: any | null | undefined;
  scheduledDeletionAt?: any | null | undefined;
};
export type useSetUserEmailNotificationsEnabledMutation$variables = {
  input: UpdateUserInput;
};
export type useSetUserEmailNotificationsEnabledMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly isEmailNotificationsEnabled: boolean;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserEmailNotificationsEnabledMutation = {
  response: useSetUserEmailNotificationsEnabledMutation$data;
  variables: useSetUserEmailNotificationsEnabledMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEmailNotificationsEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserEmailNotificationsEnabledMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserEmailNotificationsEnabledMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8776483a945f3fbcb22aa0294abe5b2",
    "id": null,
    "metadata": {},
    "name": "useSetUserEmailNotificationsEnabledMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserEmailNotificationsEnabledMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      isEmailNotificationsEnabled\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e20b447c1a74cf222d7ed82bd2ff45e";

export default node;
